export default "__VITE_ASSET__DRV2JOKu__"